import * as React from "react";
import Typography from "antd/lib/typography";
import {
    Copyright
  } from 'one-card-copyright';
const { Text } = Typography;

export const Version = ({
    versionWidth = '1105px',
}) => {
    const renderSimulator = () => (
        <Copyright version={process.env.REACT_APP_VERSION} />
    );

    return <div style={{width: versionWidth}}>{renderSimulator()}</div>;
};